/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_MemberInputs */

const en_role_member = /** @type {(inputs: Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member`)
};

const es_role_member = /** @type {(inputs: Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembro`)
};

const fr_role_member = /** @type {(inputs: Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membre`)
};

const de_role_member = /** @type {(inputs: Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied`)
};

const id_role_member = /** @type {(inputs: Role_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota`)
};

/** @type {(inputs: Role_MemberInputs) => LocalizedString} */
const ja_role_member = en_role_member;

/** @type {(inputs: Role_MemberInputs) => LocalizedString} */
const zh_role_member = en_role_member;

/** @type {(inputs: Role_MemberInputs) => LocalizedString} */
const ar_role_member = en_role_member;

/** @type {(inputs: Role_MemberInputs) => LocalizedString} */
const it_role_member = en_role_member;

/** @type {(inputs: Role_MemberInputs) => LocalizedString} */
const ru_role_member = en_role_member;

/** @type {(inputs: Role_MemberInputs) => LocalizedString} */
const pt_role_member = en_role_member;

/** @type {(inputs: Role_MemberInputs) => LocalizedString} */
const ko_role_member = en_role_member;

/**
* | output |
* | --- |
* | "Member" |
*
* @param {Role_MemberInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const role_member = /** @type {((inputs?: Role_MemberInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_MemberInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_member(inputs)
	if (locale === "es") return es_role_member(inputs)
	if (locale === "fr") return fr_role_member(inputs)
	if (locale === "de") return de_role_member(inputs)
	if (locale === "ja") return ja_role_member(inputs)
	if (locale === "zh") return zh_role_member(inputs)
	if (locale === "ar") return ar_role_member(inputs)
	if (locale === "id") return id_role_member(inputs)
	if (locale === "it") return it_role_member(inputs)
	if (locale === "ru") return ru_role_member(inputs)
	if (locale === "pt") return pt_role_member(inputs)
	return ko_role_member(inputs)
});